import Internationalize from 'components/Internationalization/Internationalize';
import StreaksWidget from './century-core/features-learner/Streaks/StreaksWidget';
import * as React from 'react';
import { parseAuthFromLocalstorage } from 'century-core/core-auth/utils/utils';
import { PolymerMatchingQuestionTypeReadonly } from './century-core/core-components/DraggableQuestionTypes/Matching/MatchingQuestionTypeReadonly';
import { PolymerLabellingQuestionTypeReadonly } from './century-core/core-components/DraggableQuestionTypes/Labelling/LabellingQuestionTypeReadonly';
import DocumentDownlodButton from 'century-core/core-components/DocumentDownloadButton/DocumentDownloadButton';
import FilteredDocsDownloader from 'century-core/core-components/DocumentDownloadButton/CombinedDocumentDownloadButton';
import PolymerToReactAuthProvider from 'century-core/core-auth/hooks/PolymerToReactAuthProvider';

export interface LocaleAndOrgType {
  locale: string;
  orgType: string;
}

const simpleContextWrapper = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: any) => {
    const auth = parseAuthFromLocalstorage();
    if (!auth) {
      return null;
    }

    return (
      <PolymerToReactAuthProvider>
        <Internationalize>
          <Component {...props} />
        </Internationalize>
      </PolymerToReactAuthProvider>
    );
  };
};

// TODO check whether we are still using this.
const PolymerAvailableReactComponents = {
  StreaksWidget: simpleContextWrapper(StreaksWidget),
  MatchingQuestionTypeReadonly: simpleContextWrapper(PolymerMatchingQuestionTypeReadonly),
  LabellingQuestionTypeReadonly: simpleContextWrapper(PolymerLabellingQuestionTypeReadonly),
  DocumentDownloadButton: simpleContextWrapper(DocumentDownlodButton),
  NuggetDocxDownloadButton: simpleContextWrapper(FilteredDocsDownloader),
};

export default PolymerAvailableReactComponents;
